import type { Filter } from '../filters/filters'
import { getListingFilterQuery } from '../filters/listing-navigation'

export function decodeSearchTerm(term?: string): string | undefined {
  if (!term) return undefined
  try {
    return decodeURIComponent(term)
  } catch {
    return term
  }
}

export function getSearchVerticalLink(query: string | undefined, vertical: string, filters: Filter[]): string {
  const parameters = new URLSearchParams({ main_category: vertical })
  parameters.set('view', 'results')
  for (const [name, value] of getListingFilterQuery(filters)) {
    parameters.set(name, value)
  }
  return `/search/${encodeURIComponent(query ?? '')}?${parameters}`
}
